<article class="card">
	<div class="support">
		<div class="header-picture"><i class="ico ico-support"></i></div>
		<div class="main-text-container">
			<div class="text">
				<h5 translate="dashboard.support.title"></h5>
				<p translate="dashboard.support.text"></p>
				<p>&nbsp;</p>
				<p translate="dashboard.support.euroasien"></p>
				<p translate="dashboard.support.us"></p>
				<p>
					<a
						class="support_link_main"
						href="{{ 'dashboard.support.email.href' | translate }}"
						translate="dashboard.support.email.name"
					></a>
				</p>
			</div>
		</div>
	</div>
	@if (supportDetails.length > 0) {
		<div class="custom-support">
			<div class="custom-text-container">
				<div class="text">
					<h5 translate="dashboard.support.title.custom"></h5>
					<p>&nbsp;</p>
					@for (detail of supportDetails; track detail; let i = $index) {
						@if (!detail.link && detail.name) {
							<p>{{ detail.name }}</p>
						}
						@if (detail.link) {
							<p>
								@if (detail.link) {
									<a href="{{ detail.link }}" [target]="getTabTarget(detail.newtab)">
										@if (detail.name) {
											<span class="support_dashboard_link support_dashboard_link_{{ detail.id }}">{{
												detail.name
											}}</span>
										}
										@if (!detail.name) {
											<span class="support_dashboard_link support_dashboard_link_{{ detail.id }}">{{
												detail.link
											}}</span>
										}
									</a>
								}
							</p>
						}
						@if (detail.type === "empty") {
							<p>&nbsp;</p>
						}
					}
				</div>
			</div>
		</div>
	}
</article>
